import {RestRequestGET} from 'libs/RestRequest';
import reduxStore from 'redux/store';
import {clearPrivileges, setPrivileges} from 'redux/actions';

const CORRESPONDENCE_PRIVILEGE_STORE_KEY = 'correspondence';
const RFX_PRIVILEGE_STORE_KEY = 'rfx';
const DEMAND_PRIVILEGE_STORE_KEY = 'demand';

const cleanupPrivileges = (id) => {
    reduxStore.dispatch(clearPrivileges(id));
}

const getPrivileges = async (url, key) => {
    const resp = await RestRequestGET(url);
    if (resp.success === true)
        reduxStore.dispatch(setPrivileges(key, resp.map))
}

export default {
    getPrivileges,
    cleanupPrivileges,
    CORRESPONDENCE_PRIVILEGE_STORE_KEY,
    RFX_PRIVILEGE_STORE_KEY,
    DEMAND_PRIVILEGE_STORE_KEY
}